import { Tooltip } from '@joor/design-system'

import { RequestStatuses, RequestStatusesType } from '../joorPayOrders.types'

export function RequestStatusCell({
  value,
}: {
  value: RequestStatusesType | string
}) {
  if (value === RequestStatuses.NOT_SENT) {
    return (
      <Tooltip
        defaultPlacement="top"
        content="If you have sent this request, check with recipient as it may not have been received"
      >
        <>{value}</>
      </Tooltip>
    )
  }
  return value
}
